<script setup lang="ts">
import { money } from '~/helpers/product/productHelper';
import type { IPriceDTO } from '~/interfaces/product/IPriceDTO';
import { MODAL_OPEN, MODAL_PROMO_PRICE, useModalStore } from '~/store/modalStore';

const modalStore = useModalStore();

const props = defineProps<{
  priceDto?: IPriceDTO
  isSmall: boolean
  wasOffer?: boolean
}>()

const {
  priceDto,
  isSmall,
  wasOffer
} = toRefs(props)

const isPromo = computed(() => {
  return !!(priceDto.value?.lowestPrice || priceDto.value?.originalPrice);
});

const currentPrice = computed(() => {
  if (priceDto.value?.hasMinPrice && priceDto.value?.minPrice && !wasOffer.value) return priceDto.value.minPrice;
  return priceDto.value?.finalPrice ?? 0;
});

const modal = () => modalStore.displayModal(MODAL_PROMO_PRICE, MODAL_OPEN);
</script>

<template>
  <div v-if="priceDto" class="cprices" data-final-price>
    <div :class="`cprices__final-price ${isPromo ? 'cprices__final-price--discounted' : ''}`">
      {{ priceDto.hasMinPrice && !wasOffer ? $t('www.cprices.starting_at') + '&nbsp;' : '' }}<span>{{ money(currentPrice) }}</span>
      <span
            v-if="false === isSmall && isPromo"
            class="pl-h pointer"
            @click="modal">
          <svg class="cicon cicon--16">
              <use xlink:href="#meilleur_offre"/>
          </svg>
      </span>
    </div>
    <div v-if="priceDto.lowestPrice && isSmall" class="cprices__other-price">
      {{ $t('www.cprices.last_lowest') }} <span class="strike-text">{{ money(priceDto.lowestPrice) }}</span>
      <span v-if="priceDto.discountFromLowestPricePercent" class="cprices__reduction">&nbsp;-{{ priceDto.discountFromLowestPricePercent }}%</span>
    </div>
    <div v-if="priceDto.originalPrice" class="cprices__other-price">
      {{ $t('www.cprices.original') }} <span class="strike-text">{{ money(priceDto.originalPrice) }}</span>
      <span v-if="priceDto.discountPercent" class="cprices__reduction">&nbsp;-{{ priceDto.discountPercent }}%</span>
    </div>
  </div>
</template>
